module.exports = __webpack_public_path__ + "static/img/top3.11a504e5.png";